import React from 'react';

import {IntegrationIcon, IntegrationIconsEnum} from '../../components/common/integrationIcon';
import {ConferenceTypesEnum} from '../../models/api/conferenceModel';

export const conferenceTypeToIcon = {
  [ConferenceTypesEnum.ZOOM]: <IntegrationIcon integrationIcon={IntegrationIconsEnum.ZOOM} />,
  [ConferenceTypesEnum.EVENT_HANGOUT]: <IntegrationIcon integrationIcon={IntegrationIconsEnum.HANGOUTS} />,
  [ConferenceTypesEnum.EVENT_NAMED_HANGOUT]: (
    <IntegrationIcon integrationIcon={IntegrationIconsEnum.HANGOUTS} />
  ),
  [ConferenceTypesEnum.HANGOUTS_MEET]: (
    <IntegrationIcon integrationIcon={IntegrationIconsEnum.HANGOUTS_MEET} />
  ),
  [ConferenceTypesEnum.SKYPE_FOR_BUSINESS]: <IntegrationIcon integrationIcon={IntegrationIconsEnum.SKYPE} />,
  [ConferenceTypesEnum.SKYPE_FOR_CONSUMER]: <IntegrationIcon integrationIcon={IntegrationIconsEnum.SKYPE} />,
  [ConferenceTypesEnum.TEAMS_FOR_BUSINESS]: <IntegrationIcon integrationIcon={IntegrationIconsEnum.TEAMS} />,
  [ConferenceTypesEnum.GOOGLE_ADD_ON]: <IntegrationIcon integrationIcon={IntegrationIconsEnum.GOOGLE} />,
};
